<template>
  <div class="grid pb-0">
    <div class="grid-title">
      <h4>{{ $t("_SALE_PACKAGE.SALE_PACKAGE") }}</h4>
      <v-btn color="primary" @click="addNew">
        <v-icon dark> mdi-plus </v-icon>
        {{ $t("_SALE_PACKAGE.ADD_NEW") }}
      </v-btn>
    </div>
    <div class="grid-body border-top-unset">
      <v-row align="center" class="pb-3 pr-3 pl-3">
        <v-col sm="4">
          <v-text-field v-model="keyword" :label="$t('_SALE_PACKAGE.ENTER_SALE_PACKAGE_NAME_OR_CODE')"
            v-on:change="getAll(1)" class="mt-0 pt-0"></v-text-field>
        </v-col>
        <v-col>
          <v-radio-group v-model="status" row class="mt-0" @change="getAll(1)">
            <v-radio :label="$t('ALL')" value="all"></v-radio>
            <v-radio :label="$t('ACTIVE')" value="1"></v-radio>
            <v-radio :label="$t('DEACTIVE')" value="0"></v-radio>
          </v-radio-group>
        </v-col>
      </v-row>
      <v-progress-linear color="warning" indeterminate rounded height="3" v-if="isLoading"></v-progress-linear>
      <loading :active.sync="isLoadingPopup" :is-full-page="false"></loading>
      <v-simple-table fixed-header height="calc(100vh - 269px)">
        <thead>
          <tr>
            <th v-for="header in headers" :class="header.class">
              <div v-if="header.value == 'status'" @click="sortStatus(asc, 1)" style="cursor: pointer">{{ header.text }}
              </div>
              <div v-else>{{ header.text }}</div>
            </th>
          </tr>
        </thead>
        <draggable v-if="!isLoading" v-model="dataTable" tag="tbody" animation="150" handle=".sort"
          @end="changeOrderList">
          <template v-if="dataTable.length > 0 && !isLoading">
            <tr v-for="(item, i) in dataTable">
              <td class="text-center vertical-middle">{{ i + 1 }}</td>
              <td class="vertical-middle">
                {{ item.ratePlanCode }}
              </td>
              <td class="vertical-middle font-weight-bold">
                <a class="app-link" href="javascript:;" @click="editItem(item)"
                  v-if="item.i18ns.filter(x => x.lang == defaultI18n).length > 0">
                  {{ item.i18ns.find(x => x.lang == defaultI18n).name }}
                </a>
              </td>
              <td class="vertical-middle">
                <template v-for="(i, index) in item.lstMealId">
                  {{ meals.find((x) => x.value == i).text }}<br />
                </template>
              </td>
              <td class="vertical-middle">
                <template v-if="!item.session">{{ $t("ALWAYS") }}</template>
                <template v-else>{{ formatDate(item.startDate) }} -
                  {{ formatDate(item.endDate) }}</template>
              </td>
              <td class="vertical-middle">
                <template v-for="(i, index) in item.listTravelAgents">
                  <span :key="index" v-if="index < 5">{{ i.id === "00000000-0000-0000-0000-000000000000" ? $t("ALL") : i.name }}<br></span>
                </template>
                <template v-if="item.listTravelAgents > 5">...</template>
              </td>
              <td class="vertical-middle">
                <template v-for="(i, index) in item.segments" >
                  <span :key="index" v-if="index < 5">{{ i.id === "00000000-0000-0000-0000-000000000000" ? $t("ALL") : i.name }}<br></span>
                </template>
                <template v-if="item.segments.length > 5">...</template>
              </td>
              <td class="text-center vertical-middle">
                <div class="d-flex justify-center">
                  <v-switch v-model="item.status" class="item-switch m-0 p-0" @change="changeStatus(item)"></v-switch>
                </div>
              </td>
              <td class="text-center vertical-middle txt-nowrap">
                <v-tooltip top transition="slide-y-reverse-transition">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn depressed @click="editItem(item)" x-small class="rounded-sm mr-1" v-bind="attrs" v-on="on"
                      color="primary" outlined>
                      <i class="icon-edit fs-16"></i>
                    </v-btn>
                  </template>
                  {{ $t("EDIT") }}
                </v-tooltip>
                <v-tooltip top transition="slide-y-reverse-transition">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn depressed color="error" @click="$refs.deleteDialogComponent.open(item)" x-small v-bind="attrs"
                      v-on="on" class="rounded-sm" outlined>
                      <i class="icon-delete fs-16"></i>
                    </v-btn>
                  </template>
                  {{ $t("DELETE") }}
                </v-tooltip>
                <v-tooltip top transition="slide-y-reverse-transition">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn depressed x-small v-bind="attrs" v-on="on" class="rounded-sm sort ml-1 mr-1" outlined
                      style="cursor: move">
                      <v-icon size="15">
                        mdi-arrow-all
                      </v-icon>
                    </v-btn>
                  </template>
                  {{ $t("SORT") }}
                </v-tooltip>
                <v-tooltip top transition="slide-y-reverse-transition">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn depressed  @click="copy(item)" x-small v-bind="attrs"
                      v-on="on" class="rounded-sm" outlined>
                      <i class="icon-content_copy fs-16"></i>
                    </v-btn>
                  </template>
                  {{ $t("DUPLICATE") }}
                </v-tooltip>
              </td>
            </tr>
          </template>
          <template v-else>
            <tr>
              <td colspan="7" class="text-center vertical-middle font-weight-bold font-italic" style="color: red">
                {{ $t("NO_DATA") }}
              </td>
            </tr>
          </template>
        </draggable>
      </v-simple-table>
      <b-row>
        <b-col md="4" class="d-flex align-center">
        </b-col>

        <b-col md="4" class="text-center">
          <a v-if="dataTable.length < paging.total" class="text-primary" @click="showMore()">{{
            $t('SHOW_MORE')
          }}
            <i class="icon-keyboard_double_arrow_down"> </i>
          </a>
        </b-col>
        <b-col md="4" class="text-right">
          <span v-if="paging" class="pr-3">{{ $tc('TO_PAGE', dataTable.length) }} | {{ $t("TOTAL") }}: {{ paging.total }}
            {{ $t("SALE_PACKAGE") }}</span>
        </b-col>
      </b-row>
      <!-- <paging v-if="paging.total" :paging.sync="paging" @changePage="changePage" class="pl-3 pr-3">
        <span slot="totalItems" v-if="paging">{{ $t("TOTAL") }}: {{ paging.total }} {{ $t("PACKAGE") }}</span>
      </paging> -->
      <delete-dialog @deleteItem="deleteItem" :maxWidth="325" ref="deleteDialogComponent">
        <span slot="title">{{ $t("CONFIRM_DELETE_SALE_PACKAGE") }}?</span>
      </delete-dialog>
      <confirm-dialog @deleteItem="changeStatusItem" @cancelDelete="cancelDelete" :maxWidth="450" :persistent="true"
        ref="changeStatusDialogComponent">
        <span slot="title">{{ $t("CONFIRM_CHANGE_STATUS_SALE_PACKAGE") }}</span>
      </confirm-dialog>
      <v-dialog v-model="dialogCopy" :max-width="325" v-if="copyItem">
          <v-toolbar class="toolbar-update" dense>
            <v-toolbar-title class="text-primary fs-15">
              <strong>{{ $t('COPY_RATE') }}</strong>
            </v-toolbar-title>
          </v-toolbar>
          <div class="content-update">
           <p> {{ $t("SALE_PACKAGE_CODE_OLD") }}: <strong  class="text-primary fs-15">{{ ratePlanCodeCopy }}</strong></p>
            <v-form ref="formCopy" lazy-validation v-on:submit.prevent>
              <label class="s-label"><span class="font-weight-bold">{{ $t("SELLING_PACKAGE_NEW") }}</span></label>
              <v-text-field v-model="copyItem.nameVi" counter maxlength="250" class="input-counter"
                        :rules="ruleName" outlined dense v-on:keyup="updateRoomTitle(copyItem.nameVi)">
                      </v-text-field>
              <label class="s-label"><span class="font-weight-bold">{{ $t("SALE_PACKAGE_CODE_NEW") }}</span></label>
              <v-text-field v-model="copyItem.ratePlanCode"
                  v-on:keyup="validateSalePackageCode(copyItem.ratePlanCode)"
                  :rules="ruleCode" :error="isDuplicateSalePackageCode" outlined counter maxlength="20"
                  class="input-counter code" dense>
                </v-text-field>
                <small v-if="isDuplicateSalePackageCode" class="text-danger">{{
                  $t("_SERVICE_PACKAGE.ERROR_SALE_PACKAGE_CODE")
                }}</small>
            </v-form>
            <div class="mt-3 d-flex justify-content-between">
              <div class="w-100 mr-1">
                <v-btn depressed block @click="dialogCopy = false; copyItem =  null">
                  {{ $t("_LOGIN.CANCEL") }}
                </v-btn>
              </div>
              <div class="w-100 ml-1">
                <v-btn class="" block color="primary" @click="confirmCopy()">
                  {{ $t("DUPLICATE") }}
                </v-btn>
              </div>
            </div>
          </div>
        </v-dialog>
    </div>
  </div>
</template>

<script>
import Paging from "@/components/Utils/Paging.vue";
import DeleteDialog from "@/components/Utils/DeleteDialog.vue";
import ConfirmDialog from "@/components/Utils/ConfirmDialog.vue";
import { salePackageService } from "@/_services/SaleRoom/sale-package.service.js";
import { _formatCurrency, _formatDate, _alert } from "@/_helpers/function.js";
import draggable from "vuedraggable";

export default {
  components: {
    "delete-dialog": DeleteDialog,
    "confirm-dialog": ConfirmDialog,
    paging: Paging,
    draggable
  },
  data() {
    return {
      roomsMaped: [],
      ratePlanCodeCopy: '',
      dialogCopy: false,
      isDuplicateSalePackageCode: false,
      isLoading: false,
      isLoadingPopup: false,
      sysLang: this.$i18n.locale,
      dialog: false,
      headers: [
        {
          text: this.$t("STT"),
          class: "text-center",
        },
        {
          text: this.$t("_SERVICE_PACKAGE.PACKAGE_CODE"),
          value: "packageCode",
          width: "10%",
        },
        {
          text: this.$t("SELLING_PACKAGE"),
          value: "name",
        },
        {
          text: this.$t("MEAL"),
          value: "meal",
          width: "25%",
        },
        {
          text: this.$t("TIME_APPLICATION"),
          value: "time",
          width: "10%",
        },
        {
          text: this.$t("TRAVEL_AGENT"),
          value: "listTravelAgents",
          width: "25%",
        },
        {
          text: this.$t("MARKET_SEGMENT"),
          value: "segments",
          width: "25%",
        },
        {
          text: this.$t("STATUS"),
          value: "status",
          class: "text-center",
        },
        {
          text: this.$t("ACTION"),
          class: "text-center",
        },
      ],
      data: [],
      dataTable: [],
      selected: [],
      keyword: "",
      status: "all",
      paging: {
        total: 0,
        limit: 15,
        offset: 0,
      },
      orderBy: "active",
      asc: false,
      meals: [],
      copyItem: null
    };
  },
  created() {
    this.listStatus = [
      { id: "all", value: this.$t("ALL")},
      {
        id: true,
        value: this.$t("ACTIVE"),
      },
      {
        id: false,
        value: this.$t("DEACTIVE"),
      },
    ];
    this.initialize();
  },
  mounted() { },
  watch: {
    dialogCopy(val) {
      if (!val) {
        this.copyItem = null;
      }
    }
  },
  methods: {
    validateSalePackageCode(salePackageCode, $event) {
      let body = {
        keyword: salePackageCode,
      };
      salePackageService.validateSalePackageCode(body).then(async (res) => {
        if (res.responseCode == 0) {
          if (res.data) {
            this.isDuplicateSalePackageCode = true;
          } else {
            this.isDuplicateSalePackageCode = false;
          }
        }
      });
    },
    updateRoomTitle(value) {
      if (value.length > 0) {
        for (let i = 0; i < this.copyItem.i18ns.length; i++) {
          this.copyItem.i18ns[i].name = value;
        }
      }
    },
    copy(item) {
      this.isDuplicateSalePackageCode = false;
      salePackageService.getDetail(item.id ).then((res) => {
        if (res.responseCode !== 0) return
        this.ratePlanCodeCopy = res.data.ratePlanCode;
        this.copyItem = JSON.parse(JSON.stringify(res.data));
        this.copyItem.nameVi = '';
        this.copyItem.ratePlanCode = '';
        delete this.copyItem.id;
        this.dialogCopy = true;
      })
    },
    confirmCopy() {
      let form_validate = this.$refs.formCopy.validate();
      if (form_validate) {
        this.copyItem.createRoomRates = this.copyItem.mappedRoomRates.map(e => Object.assign({}, {
          roomTypeId: e.roomTypeId,
          otaId: e.otaId
        }));
          this.copyItem.ratePlanCode = this.copyItem.ratePlanCode.toUpperCase();
          salePackageService.create(this.copyItem).then((res) => {
            if (res.responseCode == 0) {
              this.dialogCopy = false;
              _alert(res, this.$t("CREATE_SUCCESS"), false);
              this.getAll(true);
              this.copyItem = null;
            } else {
              _alert(res, this.$t(res.data), false);
            }
          });
      }
    },
    changeOrderList() {
      let tmp = [];
      setTimeout(() => {
        tmp = this.dataTable.map(e => { return e.id });
        salePackageService.sortIndexPlan(tmp).then(res => {
          if (res.responseCode !== 0) {
            this.getAll();
          }
          _alert(res, this.$t(res.data), false);
        });
      }, 500);
    },
    showMore() {
      if (this.paging.total - this.dataTable.length > 0) {
        this.paging.offset += this.paging.limit;
        this.getAll();
      }
    },
    initialize() {
      salePackageService.getMeal().then((res) => {
        this.meals = res.data.map((x) => {
          return {
            value: x.id,
            text: x.lookupItemI18n.find((y) => y.lang == this.defaultI18n).name,
          };
        });
        this.meals = this.meals.filter((x) => x.value);
      });

      // if (
      //   this.$session.exists() &&
      //   this.$session.getAll().ojbListOfSalePackage
      // ) {
      //   this.paging.limit = this.$session.get("ojbListOfSalePackage").limit;
      //   this.paging.offset = this.$session.get("ojbListOfSalePackage").offset;
      // }
      this.getAll(true);
    },
    async getAll(isSearching) {
      // this.$session.set("ojbListOfSalePackage", this.paging);
      this.isLoading = true;
      if (isSearching) {
        this.paging.offset = 0;
        this.data = [];
        this.dataTable = [];
      }
      let body = {};
      body.keyword = this.keyword;
      if (this.status === "all") {
        body.status = null;
      } else {
        body.status = this.status;
      }
      body.limit = this.paging.limit;
      body.offset = this.paging.offset;
      body.orderBy = this.orderBy;
      body.asc = this.asc;

      await salePackageService
        .getAllPlan(body)
        .then(res => {
          this.data = this.data.concat(res.data);
          this.dataTable = this.dataTable.concat(res.data);
          this.paging.total = res.total;
        })
        .finally(() => (this.isLoading = false));
    },
    sortStatus(asc, isSearching) {
      if (asc) {
        this.asc = false;
      } else {
        this.asc = true;
      }
      this.getAll(isSearching);
    },
    addNew() {
      this.$router.push({ name: "editSalePackages", params: { id: 0 } });
    },
    changeStatus(item) {
      let body = {
        id: item.id,
        status: item.status ? 1 : 0,
      };
      salePackageService.updateSalePackageStatus(body).then((res) => {
        if (res.responseCode !== 0) {
          item.status = !item.status;
        }
        _alert(res, this.$t(res.data), true);
      });
    },
    editItem(item) {
      this.$router.push({ name: "editSalePackages", params: { id: item.id } });
    },
    cancelDelete(item) {
      item.status = !item.status;
    },
    deleteItem(item) {
      const index = this.data.indexOf(item);
      const indexTable = this.dataTable.indexOf(item);
      salePackageService.remove(item.id).then((res) => {
        if (res.responseCode == 0) {
          this.selected.splice(this.selected.indexOf(item), 1);
          this.initialize();
        }
        _alert(res, this.$t(res.data), false);
      });
    },
    changeStatusItem(item) {
      this.isLoadingPopup = true;
      this.changeStatus(item);
    },
    formatDate: _formatDate,
    _formatCurrency: _formatCurrency,
    changePage(paging) {
      this.paging = paging;
      this.getAll();
    },
  },
};
</script>
